import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { UsersRound, Gift, History, Radio } from 'lucide-react';
import { KickletPlayers } from './KickletPlayers';
import { KickletPackages } from './KickletPackages';
import { KickletOperations } from './KickletOperations';
import { AdminKickPanel } from '../admin/AdminKickPanel';
import './kicklet.css';

const sections = [['players', 'V-Points', UsersRound], ['packages', 'Reward packages', Gift], ['activity', 'Point activity', History], ['native', 'Kick channel rewards', Radio]];

export const KickletAdminWorkspace = () => {
  const [params] = useSearchParams();
  const view = sections.some(([id]) => id === params.get('view')) ? params.get('view') : 'players';
  return <div className="kicklet-workspace" data-testid="kicklet-admin-workspace">
    <nav className="kicklet-tabs" aria-label="Kick reward sections" data-testid="kicklet-admin-tabs">{sections.map(([id, label, Icon]) => <Link key={id} to={`/admin?section=kick&view=${id}`} aria-current={view === id ? 'page' : undefined} data-testid={`kicklet-tab-${id}`}><Icon size={17} aria-hidden="true" /><span>{label}</span></Link>)}</nav>
    {view === 'players' && <KickletPlayers />}{view === 'packages' && <KickletPackages />}{view === 'activity' && <KickletOperations />}{view === 'native' && <AdminKickPanel />}
  </div>;
};